// import Vue from 'vue'
// import Vuex from 'vuex'
//数据持久化
Vue.use(Vuex)
const routers = {
  namespaced: true,
  state: () => ({
    loginstate: false,
    isLoading: false,
  }),
  mutations: {
    routers(state, newsdata) {
      state.routers = newsdata
    },
    changelogin(state, data) {
      state.loginstate = data
    },
    logout(state, data) {
      state.loginstate = data
    },
    loadingset(state, data) {
      state.isLoading = data;
    }
  
  }
}
const store = new Vuex.Store({
  modules: {
    routers: routers
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js